import { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons  
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_INVENTORY_PLAN, UPDATE_INVENTORY_PLAN } from "../../Schema/InventoryPlan";
import { SelectAcademicYear } from "../Include/DynamicSelect";
import ListPlan from "./ListPlan";
// 
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { parseISO } from "date-fns";

export default function InventoryPlanForm({ open, handleClose, setRefetch, editData, dialogTitle }) {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [academicVal, setAcademicVal] = useState({ id: "", title: "" });

  const [requireField, setRequireField] = useState(false);

  const listReqPurchMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "" },
    qty: 0,
    unitPrice: 0,
    totalPrice: 0,
    image: "",
    key: Date.now() + Math.random(),
  }

  const [listData, setListData] = useState([listReqPurchMaterial]);

  // 
  const [createInventoryPlan] = useMutation(CREATE_INVENTORY_PLAN, {
    onCompleted: ({ createInventoryPlan }) => {
      setLoading(false);
      if (createInventoryPlan?.status) {
        setAlert(true, "success", createInventoryPlan?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createInventoryPlan?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  // 
  const [updateInventoryPlan] = useMutation(UPDATE_INVENTORY_PLAN, {
    onCompleted: ({ updateInventoryPlan }) => {
      setLoading(false);
      if (updateInventoryPlan?.status) {
        setAlert(true, "success", updateInventoryPlan?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateInventoryPlan?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  // console.log("editData::", editData)

  //fromik
  const CheckValidation = Yup.object().shape({
    planFor: Yup.string().required("require!"),
    academicYearId: Yup.string().required("require!"),
    remark: Yup.string(),
    date: Yup.date(),
  });


  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      remark: "",
      planFor: "",
      date: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => { 

      // ========= Check Require ==========
      let createStatus = false;
      const BreakException = {};
      try {
        if (listData?.length !== 0) {
          listData?.forEach(function (elem) {
            // console.log("element: ", elem)
            if (
              elem?.materialId?.id !== undefined &&
              elem?.materialId?.id !== "" &&
              elem?.listMaterialUnitId?.id !== undefined &&
              elem?.listMaterialUnitId?.id !== "" &&
              elem?.qty > 0 &&
              elem?.totalPrice > 0
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequireField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequireField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }


      // ====== Create =============
      if (createStatus) {
        let listReqPurchMaterialToSubmit = listData.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
            unitPrice: 0,
            totalPrice: parseFloat(d?.totalPrice),
          }
        })

        // console.log("submit values:::", 
        //   {
        //     ...values,
        //     items: listReqPurchMaterialToSubmit,
        //   }
        // );

        setLoading(true);
        if (dialogTitle === "Create") {
          createInventoryPlan({
            variables: {
              input: {
                ...values,
                items: listReqPurchMaterialToSubmit,
              }
            }
          })
        } else { 
          updateInventoryPlan({
            variables: {
              id: editData?._id,
              input: {
                ...values,
                items: listReqPurchMaterialToSubmit,
              }
            }
          })
        }
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (academicVal?.id) {
      setFieldValue("academicYearId", academicVal?.id)
    } else {
      setFieldValue("academicYearId", "")
    }
  }, [academicVal?.id])

  console.log("Values:::", values)

  useEffect( () => {
    if (editData) {
      console.log("editData::::",editData)
      // academicYearInKhmer
      setAcademicVal({id: editData?.academicYearId?._id, title: editData?.academicYearId?.academicYearInKhmer})
      setFieldValue("academicYearId", editData?.academicYearId?._id);
      setFieldValue("remark", editData?.remark ?? "");
      setFieldValue("planFor", editData?.planFor ?? "");
      setFieldValue("date", moment(editData?.date)?.format("YYYY-MM-DD") ?? "");
    }

    if (editData?.items?.length > 0) {
      const dataFromBackend = editData?.items?.map((d) => {
        // console.log("ddddd::",d?.listMaterialUnitId);
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialKhName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
          unitPrice: d?.unitPrice || 0,
          totalPrice: d?.totalPrice || 0,
        };
      });
      // console.log("dataFromBackend::", dataFromBackend)
      setListData([...dataFromBackend]);
    }
  }, [editData, open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              បង្កើតផែនការ
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={4}>
                <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
                <SelectAcademicYear
                  selectedVal={academicVal}
                  setSelectedVal={setAcademicVal}
                />
                {!!errors.academicYearId && touched.academicYearId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.academicYearId}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <Typography className="field-title">ផែនការ</Typography>
                <FormControl fullWidth size='small'>
                    <Select
                      value={values.planFor}
                      onChange={(e) => setFieldValue("planFor", e.target.value)}
                    >
                        <MenuItem value="monthly">ប្រចាំខែ</MenuItem>
                        <MenuItem value="annual">ប្រចាំឆ្នាំ</MenuItem>
                    </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography className="field-title">កាលបរិច្ឆេទ</Typography>
                <LocalizationProvider 
                  dateAdapter={AdapterDateFns} 
                  sx={{ bgcolor: "red" }}
                >
                  <DatePicker
                      slotProps={{
                        textField: {
                          sx: {
                            "& .MuiInputBase-input": {
                              padding: "8.5px 14px",
                            },
                          },
                        },
                      }}
                      fullWidth
                      value={values?.date ? parseISO(values.date) : null}
                      format={values?.planFor === "annual" ? "yyyy" : "MM/yyyy"}
                      views={ values?.planFor === "annual" ? ['year'] : ['year','month']}
                      onChange={(date) => setFieldValue("date", date ? date.toISOString() : null)}
                      renderInput={(params) => (
                          <TextField {...params} size="small" fullWidth />
                      )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                <ListPlan
                  listData={listData}
                  setListData={setListData}
                  requireField={requireField}
                  // dialogTitle={dialogTitle}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">ចំណាំ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="ចំណាំ"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
